<template>
  <div class="box">

    <div class="typeform-widget" data-url="https://ed326.typeform.com/to/bMWooq" style="width: 100%; height: 500px;" > </div>  <div style="font-family: Sans-Serif;font-size: 12px;color: #999;opacity: 0.5; padding-top: 5px;" > powered by <a href="https://www.typeform.com//?utm_campaign=bMWooq&amp;utm_source=typeform.com-11331599-Basic&amp;utm_medium=typeform&amp;utm_content=typeform-embedded-poweredbytypeform&amp;utm_term=EN" style="color: #999" target="_blank">Typeform</a> </div>

  </div>
</template>

<script> 
const typeformEmbed = require('@typeform/embed')

export default {
  name: "feedback",
  mounted () {
    const vm = this;

    const embedElement = document.querySelector('.typeform-widget');
    
    typeformEmbed.makeWidget(
      embedElement,
      'https://ed326.typeform.com/to/bMWooq',
      {
        onSubmit: function () {
          console.log('Typeform successfully submitted');
          vm.$appInsights.trackEvent('About > Feedback > Typeform successfully submitted');
          vm.$ga.event('Typeform', 'submitted', 'About > Feedback');
        }  
      }
    )
  }
}

</script>



// WEBPACK FOOTER //
// src/components/about/Feedback.vue